export const css = {
    root: 'JPzcysPr',
    content: '-FUM7clj',
    ' _key': 'mc-widgets/glossary-view'
};
export default css;
